import React, { FunctionComponent, PropsWithChildren } from 'react'

import { AnalyticsTrackingManager } from './analyticsTracking/AnalyticsTrackingManager'
import { ProposalTrackingManager } from './ProposalTrackingManager'

interface AnalyticsTracker {
  setUserId: (id: string) => void
}

interface TrackingManagerProps extends PropsWithChildren {
  analyticsTracker?: AnalyticsTracker
}

export const TrackingManager: FunctionComponent<TrackingManagerProps> = ({
  analyticsTracker,
  children,
}: TrackingManagerProps) => {
  return (
    <ProposalTrackingManager>
      <AnalyticsTrackingManager analyticsTracker={analyticsTracker}>
        {children}
      </AnalyticsTrackingManager>
    </ProposalTrackingManager>
  )
}
